import React from 'react';
var css = {
  "container": "oalp-3amRr",
  "title": "oalp-2Dn1e",
  "listContainer": "oalp-30zcQ",
  "list": "oalp-WvQAw",
  "clicked": "oalp-3L0nd",
  "icon": "oalp-1AXSt"
};
import cx from 'classnames';
import { Icon } from 'panamera-react-ui';
var ScrollAbleList = function ScrollAbleList(_ref) {
  var data = _ref.data,
    title = _ref.title,
    metadata = _ref.metadata,
    handleListSelect = _ref.handleListSelect,
    selectedItemIcon = _ref.selectedItemIcon;
  var _ref2 = metadata || {},
    widgetStyle = _ref2.style;
  return !!(data === null || data === void 0 ? void 0 : data.length) && /*#__PURE__*/React.createElement("div", {
    style: widgetStyle,
    className: css.container
  }, title && /*#__PURE__*/React.createElement("div", {
    className: css.title
  }, title.text), /*#__PURE__*/React.createElement("div", {
    className: css.listContainer
  }, data.map(function (item, index) {
    var id = item.id,
      name = item.name,
      isSelected = item.isSelected;
    return /*#__PURE__*/React.createElement("div", {
      className: cx(css.list, isSelected ? css.clicked : ''),
      "data-index": index,
      key: index,
      id: id,
      onClick: handleListSelect
    }, name && /*#__PURE__*/React.createElement("div", {
      className: css.name
    }, name), isSelected && selectedItemIcon && /*#__PURE__*/React.createElement("div", {
      className: css.icon
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: selectedItemIcon.name,
      size: selectedItemIcon.size,
      color: selectedItemIcon.color
    })));
  }))) || null;
};
export default ScrollAbleList;